import { BaseService } from "./BaseService";

export const ElementoPrimarioConsolidadoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('elementos-primarios-consolidados/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar elementos primários consolidados:', error);
            return false;
        }
    },
    async getAnosOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('elementos-primarios-consolidados/options/anos');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de anos:', error);
            return false;
        }
    },
    async getTiposEpOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('elementos-primarios-consolidados/options/tipos-ep');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de tipos E.P:', error);
            return false;
        }
    },
    async getGerenciasOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('elementos-primarios-consolidados/options/gerencias');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de gerências:', error);
            return false;
        }
    },
    async show(tipo, id) {
        try {
            const tipoEncoded = encodeURIComponent(tipo);
            return await BaseService.fetchResponseFromAPIGet(`elementos-primarios-consolidados/${tipoEncoded}/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar elemento primário consolidado:', error);
            return false;
        }
    },
    async getEmpenhosAlocados(tipo, id) {
        try {
            const tipoEncoded = encodeURIComponent(tipo);
            return await BaseService.fetchResponseFromAPIGet(`elementos-primarios-consolidados/${tipoEncoded}/${id}/empenhos-alocados`);
        } catch (error) {
            console.error('Erro ao buscar empenhos alocados:', error);
            return {
                error: true,
                message: 'Erro ao buscar empenhos alocados'
            };
        }
    },
    async getDotacoesAlocadas(tipo, id) {
        try {
            const tipoEncoded = encodeURIComponent(tipo);
            return await BaseService.fetchResponseFromAPIGet(`elementos-primarios-consolidados/${tipoEncoded}/${id}/dotacoes-alocadas`);
        } catch (error) {
            console.error('Erro ao buscar dotações alocadas:', error);
            return {
                error: true,
                message: 'Erro ao buscar dotações alocadas'
            };
        }
    },
}

